import { svgIcon } from "@bitwarden/components";

export const AdminConsoleLogo = svgIcon`
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0.00 0.00 1226.00 374.00">
<path fill="#0d4053ff" d="
  M 27.63 130.86
  C 26.83 126.10 28.32 120.39 28.73 117.31
  Q 29.31 112.97 30.95 109.40
  Q 34.28 102.17 36.09 99.36
  Q 43.09 88.53 54.49 82.65
  Q 58.67 80.49 59.88 79.54
  C 62.02 77.85 64.47 76.18 66.93 75.13
  C 71.50 73.19 75.00 69.95 79.28 67.59
  Q 97.24 57.71 97.77 57.45
  C 101.15 55.81 103.17 54.02 106.28 52.66
  Q 107.52 52.11 109.60 50.65
  Q 114.35 47.30 115.51 46.74
  Q 123.04 43.15 130.10 38.73
  Q 136.16 34.94 138.33 33.78
  Q 145.51 29.94 146.77 29.18
  C 149.87 27.30 153.95 27.05 157.65 26.17
  Q 160.28 25.55 162.64 25.52
  Q 172.18 25.41 173.75 25.58
  Q 183.90 26.64 192.64 31.89
  Q 194.24 32.85 206.10 39.98
  Q 206.16 40.01 210.53 42.32
  C 212.71 43.47 214.78 45.38 217.12 46.49
  Q 223.01 49.26 228.80 53.22
  C 230.09 54.10 232.13 54.60 233.67 55.69
  Q 241.67 61.34 250.99 65.70
  C 254.11 67.16 257.30 69.83 260.80 71.47
  Q 263.25 72.61 264.02 73.28
  C 265.27 74.36 266.73 75.38 268.11 76.11
  Q 275.74 80.10 283.10 84.12
  Q 285.46 85.41 287.32 87.37
  Q 289.86 90.03 293.17 92.92
  Q 294.72 94.27 296.87 97.26
  Q 303.03 105.83 306.27 116.07
  Q 307.38 119.60 307.37 124.12
  Q 307.34 136.41 307.35 240.78
  Q 307.35 244.50 303.98 247.23
  C 302.71 248.25 301.56 248.46 300.02 247.74
  Q 293.41 244.68 285.07 239.60
  C 282.71 238.16 279.82 237.07 277.58 235.34
  Q 276.03 234.15 273.26 232.96
  C 271.24 232.09 269.48 230.29 267.67 229.29
  Q 263.78 227.13 260.23 224.93
  A 3.45 3.44 -74.1 0 1 258.60 222.00
  Q 258.53 184.01 258.61 141.50
  Q 258.62 138.16 256.03 131.51
  Q 254.93 128.70 252.33 125.68
  C 250.17 123.18 247.70 119.27 243.62 117.46
  C 239.55 115.66 236.17 113.18 232.17 111.29
  Q 230.00 110.26 228.19 108.91
  C 226.79 107.88 224.97 106.34 223.04 105.36
  Q 217.41 102.51 211.86 99.54
  Q 210.69 98.91 205.79 95.85
  Q 203.07 94.15 201.66 93.63
  Q 199.42 92.79 197.58 91.16
  Q 195.88 89.65 192.64 87.91
  Q 189.96 86.47 187.57 84.77
  Q 179.63 79.12 169.22 78.12
  Q 166.07 77.82 163.30 78.45
  C 160.66 79.06 158.27 78.77 155.53 80.13
  Q 152.46 81.66 150.30 82.36
  C 146.66 83.54 144.79 86.29 141.40 87.96
  C 137.32 89.97 133.76 91.61 130.44 94.21
  Q 128.21 95.95 126.91 96.68
  Q 122.09 99.37 109.12 106.12
  Q 105.49 108.02 101.06 111.20
  Q 98.36 113.13 95.76 114.50
  Q 91.55 116.70 90.32 117.57
  Q 83.61 122.30 78.27 131.35
  Q 76.58 134.21 76.01 137.85
  Q 75.19 142.98 75.19 144.75
  Q 75.20 161.01 75.23 214.25
  Q 75.23 218.00 76.00 222.79
  Q 76.69 227.07 79.20 230.62
  Q 82.79 235.69 85.57 238.68
  Q 87.65 240.91 91.95 243.05
  Q 95.48 244.81 100.99 248.55
  Q 105.43 251.56 110.24 253.97
  Q 115.90 256.82 122.26 260.69
  C 124.10 261.81 128.68 263.81 131.59 265.98
  Q 134.07 267.83 135.36 268.58
  Q 145.42 274.41 145.96 274.58
  Q 146.01 274.59 150.02 277.03
  C 153.93 279.40 158.09 280.86 162.83 280.62
  Q 165.86 280.47 170.02 280.64
  Q 174.02 280.80 178.48 279.67
  Q 181.28 278.97 185.95 275.89
  Q 186.51 275.52 193.38 271.47
  Q 209.84 261.77 212.73 260.42
  Q 215.50 259.14 220.83 255.50
  Q 224.64 252.89 229.08 250.74
  C 231.48 249.58 233.17 247.98 235.53 246.81
  Q 245.02 242.14 246.47 241.23
  Q 248.94 239.67 249.98 239.65
  Q 250.21 239.65 254.35 239.74
  Q 256.38 239.78 258.40 241.12
  Q 261.63 243.26 266.34 245.40
  Q 269.04 246.62 274.06 249.96
  Q 282.51 255.57 291.47 259.98
  C 293.95 261.20 295.72 262.88 294.52 265.72
  C 293.73 267.58 291.66 269.01 289.81 270.63
  Q 288.82 271.50 287.61 272.24
  C 283.82 274.53 280.62 277.43 276.86 278.95
  C 274.62 279.85 271.97 281.78 269.72 283.02
  Q 255.99 290.59 250.19 293.66
  C 246.90 295.39 243.75 298.32 240.31 300.08
  Q 228.06 306.34 217.28 313.31
  C 212.78 316.22 208.29 318.47 203.42 320.90
  Q 202.31 321.46 199.52 323.66
  Q 197.37 325.36 195.51 326.18
  Q 185.57 330.53 179.28 332.99
  Q 176.62 334.03 173.46 334.04
  Q 170.62 334.05 161.09 333.95
  Q 157.60 333.91 155.58 333.03
  C 153.50 332.12 150.97 331.86 148.37 330.73
  Q 141.00 327.56 134.72 323.42
  Q 128.82 319.54 123.75 316.79
  Q 112.82 310.85 108.48 308.25
  Q 92.53 298.70 82.57 293.29
  Q 78.53 291.09 73.59 287.92
  Q 68.33 284.54 64.33 282.57
  Q 57.25 279.08 53.70 276.49
  C 51.54 274.91 48.26 273.77 46.49 272.02
  C 43.40 268.96 38.67 264.72 36.24 260.75
  Q 29.43 249.59 27.72 239.01
  Q 26.88 233.87 27.57 227.01
  Q 28.25 220.15 28.27 216.08
  Q 28.40 173.57 28.24 136.07
  Q 28.23 134.45 27.63 130.86
  Z"
/>
<rect fill="#0d4053ff" x="771.83" y="44.56" width="49.62" height="212.24" rx="11.59"/>
<path fill="#0d4053ff" d="
  M 206.15 113.85
  Q 207.74 115.14 212.74 117.70
  Q 217.49 120.13 219.45 121.29
  Q 225.80 125.02 232.09 129.29
  C 237.36 132.87 240.18 137.08 242.52 143.11
  Q 243.87 146.59 243.92 152.16
  Q 244.18 181.07 243.95 209.34
  Q 243.91 214.59 242.57 218.03
  Q 240.83 222.52 238.25 226.39
  Q 236.27 229.36 232.81 231.61
  Q 222.34 238.38 216.99 241.20
  Q 208.16 245.86 205.75 247.81
  Q 202.86 250.16 199.71 251.41
  Q 197.63 252.23 194.49 254.34
  C 190.19 257.23 185.61 259.16 180.95 261.82
  Q 175.72 264.80 173.17 265.29
  Q 169.09 266.07 164.45 265.96
  Q 161.96 265.90 158.37 264.41
  C 156.25 263.53 153.20 262.69 150.57 261.11
  Q 144.53 257.51 135.04 252.10
  C 132.26 250.52 129.91 248.28 127.05 246.88
  Q 117.77 242.35 111.50 238.46
  Q 110.49 237.83 109.24 236.85
  C 106.89 235.00 103.19 233.80 101.62 232.63
  Q 99.71 231.21 94.94 226.11
  Q 92.51 223.51 91.11 219.77
  Q 90.07 217.01 90.04 212.56
  Q 89.76 169.43 90.03 146.00
  C 90.08 141.56 93.59 136.57 96.47 133.04
  Q 98.85 130.11 101.96 128.45
  Q 104.41 127.14 106.71 125.20
  Q 108.39 123.78 111.53 122.15
  Q 124.55 115.42 134.67 109.41
  C 136.48 108.34 138.48 106.45 140.76 105.26
  Q 150.09 100.40 153.06 98.82
  Q 155.25 97.66 159.03 96.27
  Q 161.40 95.41 164.57 95.38
  Q 168.95 95.34 170.25 95.45
  Q 176.87 96.03 182.13 99.37
  C 185.65 101.60 188.33 103.82 192.40 105.77
  C 198.51 108.70 202.19 110.63 206.15 113.85
  Z"
/>
<path fill="#0d4053ff" d="
  M 497.89 115.82
  Q 499.93 118.06 499.73 115.04
  C 499.54 112.11 499.88 107.36 502.68 105.57
  C 504.63 104.33 505.46 103.65 507.87 103.63
  Q 535.72 103.43 540.77 103.61
  Q 542.68 103.68 545.15 105.45
  Q 546.85 106.67 547.87 108.81
  Q 549.44 112.09 549.44 117.26
  Q 549.40 171.32 549.44 305.00
  C 549.44 306.76 548.91 308.81 547.69 310.03
  Q 545.35 312.36 542.52 313.98
  Q 540.90 314.91 536.35 314.91
  Q 524.97 314.91 513.64 314.87
  Q 508.87 314.85 507.13 313.99
  C 503.33 312.10 499.76 308.06 499.78 303.57
  Q 499.90 275.98 499.73 246.02
  Q 499.72 245.11 499.36 244.44
  A 0.59 0.58 55.4 0 0 498.46 244.27
  Q 496.95 245.58 494.07 248.40
  C 492.12 250.32 489.98 250.72 487.95 252.14
  Q 483.58 255.21 481.13 256.15
  Q 478.99 256.97 471.33 259.15
  Q 466.82 260.44 462.11 260.48
  Q 456.72 260.53 452.69 260.45
  Q 448.22 260.36 444.02 259.25
  Q 437.33 257.47 435.10 257.03
  Q 431.48 256.33 430.13 255.62
  C 423.72 252.24 420.20 250.72 416.10 247.58
  Q 415.00 246.74 409.95 242.72
  Q 405.51 239.20 399.61 230.80
  Q 393.17 221.64 388.67 210.37
  Q 387.58 207.62 387.26 205.46
  C 386.74 201.84 385.54 199.19 385.48 195.69
  C 385.44 193.68 385.51 190.38 384.73 188.00
  C 384.17 186.30 383.80 185.57 383.80 184.15
  Q 383.80 179.84 383.71 176.90
  Q 383.65 174.62 384.74 170.98
  Q 385.29 169.18 385.83 163.21
  Q 386.15 159.71 387.77 153.34
  Q 388.85 149.13 391.40 143.99
  Q 392.35 142.08 395.99 133.88
  Q 397.05 131.51 399.01 129.45
  C 401.57 126.76 403.91 123.53 406.15 121.33
  Q 414.44 113.21 417.76 111.26
  Q 421.06 109.33 424.34 107.36
  Q 427.67 105.37 431.25 104.12
  Q 432.38 103.73 439.85 101.10
  Q 443.31 99.89 446.07 99.92
  Q 456.51 100.04 466.93 99.92
  Q 469.71 99.89 473.33 101.10
  Q 481.19 103.73 483.80 104.67
  Q 485.76 105.38 487.92 106.99
  Q 493.88 111.41 497.89 115.82
  Z
  M 489.02 155.88
  C 485.80 153.06 481.11 149.76 476.46 148.81
  C 473.45 148.19 470.35 146.97 467.26 146.91
  Q 463.28 146.85 461.98 147.22
  Q 459.04 148.07 456.00 148.72
  Q 453.45 149.27 450.34 150.99
  Q 447.00 152.85 446.08 153.23
  Q 443.88 154.14 442.96 155.90
  C 441.60 158.48 437.72 162.92 436.18 166.74
  Q 430.82 180.01 436.12 193.43
  C 438.32 199.00 442.46 203.13 447.18 207.50
  C 449.27 209.44 451.67 209.73 454.37 210.76
  Q 456.51 211.57 460.32 211.61
  Q 464.42 211.66 473.73 211.58
  C 475.86 211.56 477.35 210.86 479.65 210.10
  Q 482.02 209.30 483.76 208.08
  C 488.94 204.44 495.45 198.07 497.21 191.78
  Q 502.57 172.61 491.05 157.83
  Q 490.61 157.27 489.02 155.88
  Z"
/>
<path fill="#0d4053ff" d="
  M 687.67 116.15
  A 0.70 0.70 0.0 0 0 688.90 115.77
  Q 689.34 111.60 690.33 106.78
  Q 690.54 105.78 691.80 105.26
  C 694.48 104.14 696.07 103.65 699.32 103.63
  Q 721.36 103.47 729.39 103.62
  Q 734.37 103.72 736.61 107.21
  Q 737.98 109.36 737.98 114.31
  Q 737.99 246.04 738.01 248.50
  Q 738.02 251.05 736.77 252.47
  Q 734.11 255.49 732.11 256.23
  Q 730.49 256.83 726.36 256.83
  Q 703.36 256.84 697.71 256.82
  Q 695.15 256.81 693.90 255.85
  Q 691.32 253.83 690.46 251.64
  Q 689.16 248.30 688.99 244.14
  A 0.70 0.69 -21.3 0 0 687.84 243.64
  Q 684.47 246.57 683.08 248.01
  C 679.82 251.41 677.19 252.37 672.83 255.04
  Q 670.79 256.29 667.20 257.09
  Q 662.03 258.25 658.37 259.41
  Q 654.97 260.49 651.31 260.49
  Q 643.25 260.47 640.94 260.45
  Q 637.49 260.41 634.00 259.44
  Q 631.73 258.81 628.46 258.08
  Q 625.86 257.51 622.91 256.47
  Q 613.18 253.06 604.78 247.11
  Q 601.30 244.65 597.98 241.46
  Q 593.23 236.89 591.40 234.66
  Q 589.76 232.66 587.43 228.31
  Q 586.56 226.70 585.26 225.14
  Q 583.18 222.68 582.88 221.83
  Q 581.32 217.46 580.05 215.21
  Q 578.09 211.72 577.50 208.58
  Q 577.23 207.09 575.07 199.69
  Q 574.45 197.53 574.10 194.86
  Q 573.76 192.28 573.61 191.58
  Q 573.21 189.68 573.21 188.32
  C 573.18 181.29 572.80 175.22 573.60 168.93
  Q 574.06 165.40 574.10 164.83
  Q 574.25 162.59 574.87 160.82
  Q 576.41 156.42 577.30 152.57
  C 578.73 146.32 581.44 141.81 584.28 136.12
  Q 586.65 131.35 590.53 126.97
  C 594.14 122.91 596.56 119.16 600.51 116.02
  Q 606.12 111.55 612.36 107.79
  Q 616.31 105.41 621.37 103.83
  Q 624.52 102.85 630.67 100.60
  A 10.34 10.31 -55.0 0 1 634.22 99.97
  L 658.50 99.97
  A 7.07 7.05 54.8 0 1 660.87 100.38
  Q 668.52 103.10 675.51 106.60
  Q 682.46 110.07 687.67 116.15
  Z
  M 660.37 147.51
  Q 654.59 146.07 648.95 147.49
  Q 645.58 148.34 639.27 150.78
  Q 634.81 152.50 632.84 154.67
  Q 630.23 157.53 628.16 160.21
  Q 626.23 162.71 625.00 166.61
  Q 621.24 178.49 624.03 190.24
  Q 625.32 195.66 628.53 199.56
  Q 632.56 204.48 636.95 207.67
  Q 642.21 211.49 649.28 211.56
  Q 656.03 211.63 659.88 211.66
  Q 664.16 211.68 667.48 210.41
  Q 672.88 208.34 674.60 207.09
  Q 683.22 200.85 686.59 190.48
  C 687.48 187.77 687.30 185.44 687.90 183.08
  C 688.98 178.85 687.88 174.63 686.68 170.21
  Q 685.07 164.27 681.37 159.57
  Q 677.95 155.24 676.63 154.13
  Q 672.34 150.53 667.78 149.37
  Q 663.23 148.22 660.37 147.51
  Z"
/>
<path fill="#0d4053ff" d="
  M 893.44 197.38
  Q 895.66 202.67 899.66 208.45
  Q 901.03 210.43 904.18 212.51
  Q 919.48 222.60 936.51 220.46
  Q 949.21 218.87 959.59 210.83
  C 961.04 209.71 962.83 209.48 964.51 209.77
  Q 968.86 210.54 972.83 213.15
  Q 977.48 216.21 977.54 216.24
  Q 988.35 222.53 990.11 223.63
  Q 991.34 224.41 992.21 225.88
  Q 992.86 226.99 992.88 228.74
  C 992.91 231.62 993.11 234.05 991.20 236.20
  Q 987.52 240.33 983.59 243.68
  Q 981.45 245.50 977.13 247.87
  Q 972.38 250.47 970.38 251.64
  Q 967.92 253.08 961.40 255.28
  C 955.27 257.36 951.89 258.03 945.51 259.61
  Q 942.16 260.44 938.78 260.46
  Q 933.49 260.50 923.00 260.49
  Q 919.50 260.49 916.19 259.34
  Q 914.17 258.65 901.72 256.67
  Q 900.04 256.41 898.59 255.65
  C 897.54 255.10 896.02 254.18 894.60 253.68
  Q 893.06 253.12 888.69 251.47
  Q 885.96 250.44 883.12 248.35
  Q 878.00 244.58 872.37 241.39
  Q 869.84 239.96 864.01 232.75
  Q 863.63 232.28 857.64 224.28
  Q 854.54 220.13 853.53 217.03
  C 852.41 213.60 850.16 210.38 849.31 206.43
  Q 848.60 203.18 847.08 199.18
  C 846.15 196.73 845.95 193.84 845.46 190.71
  Q 845.19 188.91 845.19 187.27
  Q 845.18 176.33 845.18 174.11
  C 845.19 171.02 845.63 167.40 846.32 164.80
  Q 849.11 154.31 851.67 147.93
  Q 854.27 141.47 857.51 137.18
  Q 859.63 134.38 860.76 131.80
  C 861.86 129.29 864.86 127.00 866.78 124.48
  Q 871.57 118.20 878.54 114.10
  Q 884.88 110.37 884.99 110.30
  Q 886.10 109.60 890.87 106.79
  Q 894.15 104.86 897.15 104.17
  Q 897.99 103.97 907.07 100.95
  Q 910.18 99.91 913.59 99.94
  Q 921.81 100.00 936.10 99.95
  Q 939.62 99.94 943.15 101.06
  Q 950.49 103.41 953.54 104.48
  C 960.09 106.80 967.17 109.40 971.99 113.82
  Q 972.08 113.90 979.66 119.86
  Q 981.79 121.54 982.49 122.20
  Q 983.89 123.51 984.98 125.08
  Q 986.39 127.11 988.67 129.84
  C 991.23 132.92 993.34 137.73 994.94 140.59
  C 998.26 146.54 1000.18 153.43 1001.96 160.11
  Q 1002.97 163.93 1002.86 167.07
  Q 1002.77 169.32 1003.36 171.74
  Q 1003.69 173.12 1003.71 176.35
  Q 1003.75 183.62 1003.61 185.79
  Q 1003.50 187.42 1002.28 190.02
  Q 1001.40 191.89 999.34 193.10
  Q 994.46 195.98 991.50 195.98
  Q 943.79 195.95 894.35 196.00
  Q 892.86 196.00 893.44 197.38
  Z
  M 896.10 164.38
  L 956.46 164.38
  A 1.23 1.23 0.0 0 0 957.69 163.10
  Q 957.56 159.82 955.85 155.21
  Q 955.17 153.36 953.24 151.32
  Q 951.52 149.50 948.35 146.38
  C 945.96 144.04 943.08 143.19 939.89 141.45
  C 938.45 140.67 937.13 140.73 935.26 140.59
  Q 934.48 140.53 931.86 139.66
  Q 926.02 137.73 920.51 139.56
  Q 917.65 140.52 915.74 140.82
  Q 913.89 141.11 911.05 142.55
  C 907.03 144.59 903.12 146.99 900.62 150.54
  Q 896.59 156.25 895.17 160.17
  Q 894.69 161.50 895.45 163.91
  Q 895.60 164.38 896.10 164.38
  Z"
/>
<path fill="#0d4053ff" d="
  M 1135.13 116.31
  Q 1135.36 113.76 1135.31 110.51
  C 1135.25 106.83 1136.69 105.72 1140.30 104.23
  Q 1141.90 103.56 1144.15 103.56
  Q 1168.01 103.57 1174.27 103.57
  Q 1181.92 103.57 1184.05 111.22
  Q 1185.20 115.35 1185.19 119.75
  Q 1185.04 239.93 1184.97 243.28
  Q 1184.83 249.41 1181.76 253.28
  Q 1179.12 256.61 1174.28 256.69
  Q 1170.49 256.76 1144.26 256.93
  Q 1138.66 256.97 1136.19 252.44
  C 1134.91 250.10 1135.29 247.00 1135.13 244.19
  A 0.74 0.73 64.3 0 0 1133.85 243.74
  Q 1132.35 245.42 1130.36 246.82
  Q 1127.19 249.06 1125.13 251.12
  Q 1124.19 252.07 1120.43 253.87
  Q 1113.18 257.33 1106.14 259.16
  Q 1101.41 260.38 1095.87 260.45
  Q 1094.83 260.46 1088.00 260.50
  Q 1083.69 260.52 1080.19 259.63
  Q 1072.71 257.74 1067.54 256.12
  C 1063.57 254.87 1059.89 252.76 1055.59 250.68
  Q 1053.09 249.48 1051.19 247.91
  Q 1045.93 243.58 1037.88 235.12
  Q 1034.62 231.69 1031.98 227.14
  Q 1024.62 214.46 1021.34 200.14
  Q 1020.19 195.10 1020.18 187.32
  Q 1020.16 172.72 1020.15 172.34
  Q 1019.97 166.40 1021.09 161.74
  Q 1022.91 154.22 1023.80 151.33
  Q 1024.95 147.55 1027.66 141.78
  Q 1029.30 138.28 1030.47 135.52
  Q 1031.85 132.26 1034.02 129.70
  Q 1034.99 128.57 1040.69 121.95
  Q 1043.32 118.90 1045.48 117.23
  C 1047.75 115.49 1049.61 113.37 1052.46 111.60
  Q 1063.63 104.66 1075.64 101.05
  Q 1079.19 99.98 1084.00 99.96
  Q 1096.63 99.92 1101.50 99.95
  Q 1105.00 99.97 1108.20 101.09
  Q 1114.65 103.36 1117.08 104.27
  C 1120.38 105.51 1123.16 107.58 1126.09 109.42
  Q 1130.29 112.06 1134.14 116.62
  A 0.56 0.56 0.0 0 0 1135.13 116.31
  Z
  M 1092.32 148.23
  Q 1090.03 148.89 1089.53 149.01
  Q 1087.79 149.46 1086.84 150.04
  C 1083.11 152.35 1078.91 153.93 1076.03 157.99
  Q 1066.86 170.94 1069.39 186.43
  Q 1070.63 193.97 1074.83 200.00
  C 1077.09 203.25 1080.09 205.20 1084.13 208.39
  Q 1086.02 209.89 1089.93 210.96
  Q 1092.03 211.54 1096.14 211.59
  Q 1096.28 211.59 1105.55 211.62
  Q 1109.14 211.62 1111.89 211.02
  Q 1116.51 209.99 1118.01 209.02
  Q 1120.83 207.17 1129.26 198.02
  Q 1130.08 197.14 1130.86 194.89
  Q 1134.83 183.43 1133.14 171.88
  Q 1132.44 167.11 1129.92 163.31
  Q 1125.92 157.30 1120.31 152.88
  Q 1116.67 150.01 1114.60 149.47
  Q 1107.16 147.54 1104.79 147.11
  Q 1099.52 146.15 1092.32 148.23
  Z"
/>
</svg>
`;
